<template>
  <div class="row">
    <div class="col-md-3">
      <div class="form-group">
        <datepicker
          :input-class="'form-control'"
          :format="'dd-MM-yyyy'"
          v-model="durDate"
          @selected="getDateData($event)"
          :disabledDates="disabledDates"
        ></datepicker>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group">
        <select class="form-control" v-model="selField" name="raw-data-columns">
          <option
            v-for="(d, index) in filterOptions"
            v-bind:key="d.id+index"
            :value="d.id"
          >{{d.value}}</option>
        </select>
      </div>
    </div>
    <div class="col-md-2">
      <div class="form-group">
        <input class="form-control" v-model="min" placeholder="Min" />
      </div>
    </div>
    <div class="col-md-2">
      <div class="form-group">
        <input class="form-control" v-model="max" placeholder="Max" />
      </div>
    </div>
    <div class="col-md-2">
      <div class="form-group">
        <button @click="filterData" class="btn btn-sm btn-primary" type="button">
          <i class="fa fa-filter" title="Filter"></i>
        </button>
      </div>
    </div>
    <div class="col-md-3" v-if="isSectors">
      <div class="form-group">
        <!-- <input type="text" v-model="searchParams.sectorname" class="form-control" name="sector" placeholder="Search by Sector"/> -->
        <select class="form-control" name="sector" v-model="sector">
          <option value>Select Sector</option>
          <option
            v-for="(sec, index) in sectorData"
            :value="sec.sect_name"
            v-bind:key="sec.sect_code+index"
            readonly
          >{{sec.sect_name}}</option>
        </select>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import Datepicker from "vuejs-datepicker";
export default {
  components: { Datepicker },
  // props: ["minRange", "maxRange", "filterOptions", "ddate", "selFilter"],
  props: ["filterOptions", "dDate", "showSector"],
  data() {
    return {
      durDate: new Date().setDate(new Date().getDate() - 1),
      min: "",
      max: "",
      selField: "",
      sector: "",
      sectorData: [],
      disabledDates: {
        from: new Date(new Date().setDate(new Date().getDate() - 1))
      },
      isSectors: 0
    };
  },
  created() {
    // console.log("tabelId", this.tableId, "Filename", this.fileName);
    if (this.showSector) {
      console.log("Sectors", this.isSectors, this.showSector);
      this.isSectors = this.showSector;
      this.getSectorData();
    }
    console.log(this.filterOptions);
    // this.ddate = new Date().setDate(new Date().getDate()-1);
  },
  methods: {
    filterData() {
      console.log("Filter data");
      this.$emit("filter", {
        durDate: this.durDate,
        min: this.min,
        max: this.max,
        selField: this.selField,
        sector: this.sector
      });
    },
    filterDate() {
      console.log("Filter DATE");
      this.$emit("filterDate", {
        durDate: this.durDate
      });
    },
    getDateData(e) {
      console.log("Date Selected", e);
      this.durDate = e;
      this.filterDate();
    },
    clearFilterData() {
      this.min = "";
      this.max = "";
      this.selField = "";
    },
    getSectorData() {
      let _this = this;
      http.get("getSectorList", {}, function(error, response) {
        // console.log("Sector Data", response);
        _this.sectorData = response;
      });
    }
  },
  watch: {
    dDate: function(value) {
      console.log("Date changed", value);
      this.durDate = value;
    },
    showSector: function(value) {
      this.isSectors = value;
      console.log("Sectors", this.isSectors, value);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/FiltersMrkt.vue